// extracted by mini-css-extract-plugin
export const header = "header-module--header--1O26W";
export const inner = "header-module--inner--JJ_Ib";
export const logo = "header-module--logo--3DCRu";
export const mark = "header-module--mark--3i8NG";
export const cursor = "header-module--cursor--1MJox";
export const text = "header-module--text--3ydw6";
export const right = "header-module--right--2i53k";